import { render, staticRenderFns } from "./AnexosAbel.vue?vue&type=template&id=6dba838f&scoped=true&"
import script from "./AnexosAbel.vue?vue&type=script&lang=js&"
export * from "./AnexosAbel.vue?vue&type=script&lang=js&"
import style0 from "./AnexosAbel.vue?vue&type=style&index=0&id=6dba838f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dba838f",
  null
  
)

export default component.exports